import { createModel } from '@rematch/core';

import type { RootModel } from 'store/models';
import type { ICriticalReadingTemplateAnswers } from 'infrastructure/interfaces/i-rpm-patient-activity';

export type TActionValue = {
  isTemplateBased?: boolean;
  /**
   * Set by the Nurse-MA critical-reading templates (wizard / Weight Management) on
   * save and sent with the comment. The server decides from these answers whether
   * the comment flips the monthly interaction status, so the comment-send flow must
   * not prompt/flip it client-side when they are attached.
   */
  criticalReadingTemplate?: ICriticalReadingTemplateAnswers;
  sending?: boolean;
  message?: string;
  assessments?: {
    [k: string]: Record<string, any>;
  };
};

export type TAction = Record<string, TActionValue>;
export type TState = {
  actions: TAction;
  aiCommentGenCount: number;
};

const INITIAL_STATE: TState = {
  actions: {},
  aiCommentGenCount: 0,
};

const activityActions = createModel<RootModel>()({
  state: INITIAL_STATE,
  reducers: {
    updateAction: (
      { actions, ...other },
      { idx, action }: { idx: number | string; action: TActionValue },
    ) => ({
      ...other,
      actions: {
        ...actions,
        [idx]: { ...actions[idx], ...action },
      },
    }),
    resetActions: (state) => ({ ...state, actions: {} }),
    resetCurrentActions: (state, idx: number | string) => ({
      ...state,
      actions: { ...state.actions, [idx]: {} },
    }),
    increaseAiCommentCount: ({ aiCommentGenCount, ...other }) => ({
      ...other,
      aiCommentGenCount: aiCommentGenCount + 1,
    }),
    decreaseAiCommentCount: ({ aiCommentGenCount, ...other }) => ({
      ...other,
      aiCommentGenCount: aiCommentGenCount - 1,
    }),
  },
});

export default activityActions;
